import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { SplashScreen } from "@capacitor/splash-screen";
import App from "./App";
import "./index.css";

// Initialize Firebase (side-effect import ensures early init)
import "./config/firebase";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Hide splash screen after React has rendered
SplashScreen.hide({ fadeOutDuration: 300 }).catch(() => {
  // Not running in Capacitor — ignore
});
